import React from 'react';

const Logo = () => (
  <div className="starfield">
    <div className="layer1" />
    <div className="layer2" />
    <div className="layer3" />
    <div className="logo">
      <img src="/images/logo.svg" alt="" />
      <h1 className="text-white mt-5">
        Home of <em>Red Dwarf</em>.
      </h1>
      <h2 className="text-white">
        Producing smash-hit, award-winning television since 1990.
      </h2>
    </div>
  </div>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.jsx